/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import clipboard from 'clipboard';

function copyText(_text) {
  var div = document.createElement("div");
  var clip = new clipboard(div, {
    text: function text() {
      return _text;
    }
  });
  div.click();
  clip.destroy();
  div.remove();
}

export { copyText as default };
//# sourceMappingURL=clipboard.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/utils/clipboard.js
// module id = null
// module chunks = 